import { reportingService } from './reportingService';

export default reportingService;
